import { graphql } from 'gql.tada';

export const SchoolSelectorFragment = graphql(`
  fragment SchoolSelectorFragment on User {
    id
    email
    schoolsAsPrimaryAdmin {
      id
      name
      slug
    }
  }
`);
